var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEurope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg75",
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs79"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path87",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g81",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g85",
    clipPath: "url(#clipPath89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g91",
    transform: "translate(460.3955,75.397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 3.592,0.868 7.225,1.563 10.884,2.082 3.903,0.552 8.437,1.291 10.337,4.751 0.878,1.601 0.989,3.496 1.082,5.319 0.478,9.473 0.313,20.475 -7.074,26.406 -3.06,2.456 -6.926,3.608 -10.483,5.261 -10.747,4.995 -13.066,22.05 -9.235,28.487 3.831,6.437 48.58,-19.772 48.58,-19.772 l 0.011,271.02",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path93",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g95",
    transform: "translate(106.7466,219.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.729,1.022 -16.404,1.384 -20.306,-2.838 -6.91,-8.536 -3.075,-21.079 0.507,-31.467 3.583,-10.389 5.786,-23.86 -2.804,-30.695 -7.756,-6.171 -19.07,-2.62 -28.22,1.179 l -22.758,9.448 c -5.901,2.45 -12.609,-0.842 -14.296,-7.017 l -8.707,-31.865 c -1.767,-6.467 -3.546,-13.233 -2.176,-19.795 2.436,-11.658 14.054,-19.123 25.478,-22.408 7.87,-2.263 16.111,-3.202 24.071,-5.048 5.767,-1.338 11.629,2.017 13.261,7.72 1.408,4.92 3.171,9.707 5.748,14.113 4.475,7.648 11.872,14.103 20.654,15.173 4.346,0.53 9.573,0.086 12.191,3.603 2.062,2.771 1.396,6.788 3.045,9.823 3.01,5.54 10.993,4.658 17.247,3.94 10.563,-1.213 21.424,0.41 31.212,4.561 4.728,2.005 10.275,0.558 13.278,-3.615 7.512,-10.44 12.104,-29.267 18.853,-40.421 6.616,-10.932 11.338,-12.823 11.266,-29.018 -7.372,-4.63 -13.473,-12.143 -22.139,-11.374 -2.067,-3.083 9.636,-13.89 12.968,-15.515 3.332,-1.625 7.283,-1.123 10.891,-0.277 12.503,2.928 17.444,14.3 18.932,16.911 1.488,2.61 9.013,4.837 9.013,4.837 1.293,-0.983 3.182,-0.769 4.126,0.554 1.835,2.569 1.84,6.595 0.256,9.525 -2.088,3.862 -5.997,6.311 -9.616,8.789 -12.341,8.45 -13.87,32.456 -22.371,44.778 -1.969,2.854 -3.686,6.447 -4.432,9.943 -1.232,5.771 4.96,10.263 10.041,7.28 l 40.66,-23.866 c 2.321,-1.363 4.73,-2.806 6.188,-5.073 3.795,-5.897 -0.52,-13.945 1.517,-20.659 1.571,-5.179 6.499,-8.425 10.514,-12.046 4.015,-3.621 1.601,-11.384 5.28,-14.178 2.446,-1.004 5.293,-0.909 7.709,0.149 1.877,0.822 3.885,1.252 5.933,1.276 4.869,0.057 10.015,1.827 9.001,6.439 -0.204,0.931 -0.671,1.783 -1.255,2.535 l -8.006,16.262 c -1.303,4.848 3.826,5.648 6.697,5.773 2.872,0.126 9.882,0.026 13.621,0.028 3.739,0.001 22.017,16.56 23.321,23.886 1.555,8.744 3.11,17.487 4.666,26.231 0.711,4.001 1.558,8.271 4.432,11.138 2.873,2.867 6.191,-2.224 10.518,-0.267 5.603,2.533 2.21,9.466 10.047,9.639 3.003,0.066 5.824,-1.423 7.534,-3.897 0.722,-1.044 1.582,-1.867 3.091,-1.744 0.709,0.058 1.383,0.355 1.951,0.785 5.845,4.43 10.183,10.5 15.653,15.359 5.168,4.591 15.737,10.51 18.768,6.955 3.03,-3.554 7.7,-18.186 -16.02,-31.611 -5.089,-2.879 -5.207,-7.094 -2.542,-12.62 1.173,-2.431 3.754,-3.84 6.448,-3.881 6.3,-0.094 15.359,8.789 25.992,0.09 0.793,-0.649 6.26,-15.848 -5.205,-19.089 -15.665,-4.428 -22.134,-3.792 -40.8,-6.214 -8.572,-1.113 -17.883,-2.593 -23.751,-8.952 -4.171,-4.519 -6.084,-11.049 -11.092,-14.615 -2.71,-1.929 -6.107,-2.801 -8.61,-4.993 -3.904,-3.418 -4.709,-9.386 -3.327,-14.393 1.382,-5.007 4.561,-9.291 7.673,-13.444 1.967,-2.624 4.043,-5.341 6.983,-6.786 2.384,-1.172 5.125,-1.391 7.779,-1.28 15.669,0.649 30.859,11.873 45.876,7.339 3.17,-0.957 6.219,-2.611 9.53,-2.638 4.492,-0.036 8.386,2.888 12.064,5.471 3.165,2.223 6.443,4.285 9.815,6.179",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path97",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g99",
    transform: "translate(504.4985,431.6948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0.001,43.305 c 0,0 -48.284,-0.315 -54.752,-0.038 -11.234,0.481 -22.187,-3.6 -30.375,-11.323 l -44.253,-41.743 c -2.743,-2.586 -5.666,-5.536 -5.954,-9.299 -0.264,-3.461 1.796,-6.653 2.37,-10.077 1.545,-9.228 -8.713,-17.032 -18.028,-16.388 -5.104,0.354 -9.777,2.408 -14.06,5.267 -5.02,3.351 -6.058,10.374 -2.012,14.858 2.606,2.888 4.792,6.164 6.461,9.681 2.563,5.399 -0.263,11.832 -5.926,13.713 l -23.411,7.778 c -11.331,3.765 -23.316,7.575 -35,5.122 -16.996,-3.567 -28.509,-19.201 -37.062,-34.346 -8.554,-15.146 -16.601,-31.833 -31.499,-40.775 -4.722,-2.834 -9.973,-4.765 -14.467,-7.952 -4.205,-2.983 -21.103,-23.728 -17.94,-31.241 1.976,-4.694 6.608,-7.667 11.678,-8.054 10.603,-0.811 18.529,6.008 25.862,12.521 -2.222,-17.277 -3.234,-48.648 7.992,-49.89 11.226,-1.244 26.941,31.67 27.318,41.878 0.378,10.208 -8.351,9.57 -7.82,15.858 0.53,6.288 3.377,12.101 5.424,18.068 4.14,12.071 5.473,25.905 17.373,33.345 5.418,3.388 12.522,3.143 17.27,-1.136 5.313,-4.788 4.308,-11.44 1.829,-16.857 -3.215,-7.023 -8.776,-12.789 -11.807,-19.894 -3.031,-7.104 -2.478,-16.912 4.233,-20.717 7.159,-4.061 15.772,1.065 22.941,5.108 7.169,4.043 18.033,6.187 22.126,-0.964 -2.288,-11.562 -4.772,-23.573 -11.912,-32.94 -7.141,-9.367 -20.415,-15.166 -30.999,-10.024 -5.222,-0.838 -8.059,-6.757 -8.427,-12.043 -0.368,-5.286 0.815,-10.692 -0.397,-15.85 -3.446,-14.672 -22.316,-18.266 -37.343,-18.879 -9.957,-0.405 -19.914,-0.811 -29.871,-1.217 -2.013,-0.082 -4.238,-0.095 -5.77,1.216 -1.642,1.406 -1.896,3.82 -1.952,5.983 -0.206,7.993 3.901,17.446 -1.402,23.9 -4.323,4.101 -17.069,3.037 -19.255,-2.512 -2.186,-5.548 1.845,-16.271 -2.233,-21.767 -4.077,-5.496 -14.687,-7.752 -21.437,-19.901 -1.867,-3.359 -3.345,-7.07 -6.187,-9.654 -1.984,-1.805 -4.462,-2.899 -7.014,-3.789",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path101",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEurope);
export default __webpack_public_path__ + "static/media/icon-europe.535391b99ae85d441b87e57d79f83201.svg";
export { ForwardRef as ReactComponent };